'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var styledComponents = require('./styled-components.js');

var StatusBadge = function (props) {
    var label = props.label, color = props.color;
    return (React__default.createElement(styledComponents.StatusContainer, null,
        React__default.createElement(styledComponents.ColoredCircle, { "data-testid": 'status-color', color: color }),
        React__default.createElement(core.Typography, { variant: 'body1', style: { paddingTop: '0.2rem' } }, label)));
};

module.exports = StatusBadge;
